import { Box, Grid, Typography } from '@mui/material';
import React from 'react'
import BookingCard from '../../components/BookingCard';


function Meetings() {
  const [data, setData] = React.useState([])
  const [status, setStatus] = React.useState(true)
  return (
    <>
      <Box p={2}>
        <Typography variant="h4" gutterBottom>
          Bookings
        </Typography>
        <Grid container spacing={2}>

          {status ? (
            data.map((booking) => (
              <Grid item xs={12} md={6} lg={4}>
                <BookingCard key={booking.id} booking={booking} />
              </Grid>
            ))
          ) : <></>}
        </Grid>

      </Box>
    </>


  )
}

export default Meetings
